import type { ResubscriptionModalData } from '@library/api-customer-engagement-experience'

const isNonBlankString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const isValidAnalytics = (analytics: unknown): boolean =>
  analytics === undefined ||
  (isRecord(analytics) &&
    isNonBlankString(analytics.category) &&
    isNonBlankString(analytics.action))

const isValidAction = (action: unknown): boolean =>
  isRecord(action) &&
  isNonBlankString(action.intent) &&
  isNonBlankString(action.title) &&
  isValidAnalytics(action.analytics)

/**
 * The xAPI body is only type-cast when parsed, so this checks every field the modal reads before the
 * content is kept. Anything that fails stays a no-op instead of crashing the menu.
 */
export const isRenderableResubscriptionModalData = (
  data: unknown,
): data is ResubscriptionModalData =>
  isRecord(data) &&
  isNonBlankString(data.headline) &&
  isNonBlankString(data.message) &&
  (data.badge === undefined || (isRecord(data.badge) && isNonBlankString(data.badge.label))) &&
  isValidAction(data.primaryAction) &&
  (data.secondaryAction === undefined || isValidAction(data.secondaryAction)) &&
  isValidAnalytics(data.dismissAnalytics)
